'use client';

import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const labelVariants = cva(
  // Base: NO display style here
  'text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
  {
    variants: {
      variant: {
        default: '',
        subheading: 'text-affidea-gray text-sm/6 font-normal',
      },
      size: {
        sm: 'text-xs',
        md: 'text-sm',
        lg: 'text-base',
      },
      // NEW: choose how the label lays out
      layout: {
        control: 'inline-flex items-center gap-2', // for checkbox/radio next to short text
        text: 'block',                              // for long paragraph-like labels
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
      layout: 'control', // keep current behavior by default
    },
  }
);

function Label({ className, variant, size, layout, ...props }) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(labelVariants({ variant, size, layout }), className)}
      {...props}
    />
  );
}

export { Label };
